import { render, staticRenderFns } from "./TxAddToCartPortal.vue?vue&type=template&id=c45c19be&scoped=true&"
import script from "./TxAddToCartPortal.vue?vue&type=script&lang=js&"
export * from "./TxAddToCartPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45c19be",
  null
  
)

export default component.exports